import { all, fork, put, takeEvery } from 'redux-saga/effects';
import callToAPI from '../../../utils/callToAPI';
import * as Api from '../../api/ncs';
import * as types from './types';

function* deleteNC({ payload }) {
  yield callToAPI({
    apiCall: Api.deleteNC,
    successResponseCode: 200,
    errorType: types.DELETE_NC_ERROR,
    *callback() {
      yield put({
        type: types.DELETE_NC_SUCCESS,
        payload,
      });
    },
    payload,
  });
}

function* getNCs({ payload }) {
  yield callToAPI({
    apiCall: Api.getNCs,
    successResponseCode: 200,
    errorType: types.GET_NCS_ERROR,
    *callback({ data: { data, total } }) {
      yield put({
        type: types.GET_NCS_SUCCESS,
        payload: {
          data: data,
          total: total,
        },
      });
    },
    payload,
  });
}

function* watcherDeleteNC() {
  yield takeEvery(types.DELETE_NC_REQUEST, deleteNC);
}
function* watcherGetNCs() {
  yield takeEvery(types.GET_NCS_REQUEST, getNCs);
}

export default function* rootSaga() {
  yield all([fork(watcherGetNCs), fork(watcherDeleteNC)]);
}
